// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__1OvU7","text":"style_text__1oyDG","poweredImg":"style_poweredImg__3tnnp"};